import React, { useContext } from 'react';
import styled from 'styled-components';

import { Img } from 'react-image';
import { ConfigContext } from 'contexts/ConfigContext';

const LogoContainer = styled.span`
img {
    max-width: ${props => props.$maxWidth};
    max-height: ${props => props.$maxHeight};
    width: auto;
    height: auto;

    @media (max-width: 640px) {
        max-width: ${props => props.$maxWidthMobile};
        max-height: ${props => props.$maxHeightMobile};
    }
}
`;

const Logo = () => {

    const { clientConfig, tenantConfig } = useContext(ConfigContext)
    const { logo } = clientConfig
    const { CloudFilesContainerUrl, TenantName } = tenantConfig

    const getLogoUrl = () => {
        if (logo.url) {
            if (logo.url.indexOf("http") === 0) {
                return logo.url;
            } else {
                return CloudFilesContainerUrl + "/tenantassets/" + logo.url;
            }
        }
        return CloudFilesContainerUrl + "/tenantassets/logo.png";
    }

    const logoUrl = getLogoUrl();

    return (
        <LogoContainer
            $maxWidth={logo.maxWidth}
            $maxWidthMobile={logo.maxWidthMobile}
            $maxHeight={logo.maxHeight}
            $maxHeightMobile={logo.maxHeightMobile}
        >
            {logo.link ? (
                <a href={logo.link} target="_blank" rel="noopener noreferrer">
                    <Img
                        key={logoUrl}
                        src={[logoUrl]}
                        unloader={<h1>{TenantName}</h1>}
                    />
                </a>
            ) : (
                <Img
                    key={logoUrl}
                    src={[logoUrl]}
                    unloader={<h1>{TenantName}</h1>}
                />
            )}
        </LogoContainer>
    );
};

export default Logo;
